import React, { Component } from 'react';
import Icon from '../../../icons/Icon';
import { AnimatedButton } from '@trlogic/ui-pack';
import LanguageUtil from '../../../util/LanguageUtil';

class ChartEditorComponent extends Component<Props, State> {
  public state = new State();

  render() {
    const {
      title = '',
      description = '',
      onChangeTitle,
      onChangeDescription,
      onSave,
      onRemove,
      disableSave,
      disableRemove,
      disableDescriptionChange,
      descriptionVisible,
      icon,
    } = this.props;

    return (
      <div
        id='information-container'
        className={
          'flex select-none w-full px-5 py-5 font-custom justify-center gap-y-5 gap-x-5 lg:justify-start items-start lg:items-center  flex-col lg:flex-row font-formica'
        }
      >
        <div id='edit-section' className={'flex items-center justify-start w-full gap-x-5'}>
          <div id='icon' className={`rounded-full w-[80px] h-[80px] min-h-[80px] min-w-[80px] shrink-0 flex items-center justify-center`}>
            {icon && (
              <div id='icon' className={'text-f-purple'}>
                <Icon icon={icon} size={30} />
              </div>
            )}
          </div>
          <div id={'editable-fields'} className={'flex flex-col w-full'}>
            <div className={'flex items-center'}>
              <input
                value={title || ''}
                onChange={(e) => onChangeTitle(e.currentTarget.value)}
                className={'w-full h-[40]px select-none text-[30px] bg-transparent border-none shadow-none hover:border-none focus:outline-none text-f-black-2'}
                placeholder={LanguageUtil.get({ id: 'common.label.title', defaultMessage: 'Title' })}
              />
            </div>
            {(descriptionVisible == undefined || descriptionVisible) && (
              <div className={'flex items-center group relative '}>
                <textarea
                  value={description || ''}
                  onChange={(e) => onChangeDescription(e.currentTarget.value)}
                  disabled={disableDescriptionChange}
                  className={
                    'w-[98%] h-[30px] bg-white custom-editor-component-description hover:border-b-[1px] hover:border-f-purple flex items-center justify-start py-1.5 text-start text-lg focus:border-b-[1px] focus:border-f-purple resize-none focus:outline-none text-f-black-2'
                  }
                  placeholder={LanguageUtil.get({ id: 'common.label.description', defaultMessage: 'Description' })}
                />
                <div
                  className={
                    'hidden group-focus-within:flex group-hover:flex absolute z-index-100 transition-all top-1/2 text-f-purple  transform -translate-x-1/2 -translate-y-1/2 -right-2 '
                  }
                >
                  <Icon icon={'edit'} size={20}></Icon>
                </div>
              </div>
            )}
          </div>
        </div>
        <div id={'controller-container'} className={'flex gap-x-5 lg:w-full items-end justify-end'}>
          {onSave && (
            <AnimatedButton
              onClick={() => onSave && onSave()}
              icon={'save'}
              text={LanguageUtil.get({ id: 'common.button.save', defaultMessage: 'Save' })}
              disabled={disableSave || this.props.loading}
              customType={'outlined'}
            />
          )}
          {onRemove && (
            <AnimatedButton
              onClick={(e) => onRemove(e)}
              icon={'delete'}
              text={LanguageUtil.get({ id: 'common.button.remove', defaultMessage: 'Remove' })}
              disabled={disableRemove || this.props.loading}
              customType={'secondary'}
            />
          )}
        </div>
      </div>
    );
  }
}

interface Props {
  title: string;
  description: string;
  icon?: string;
  onChangeTitle: (e: string) => void;
  onChangeDescription: (e: string) => void;
  onSave?: () => void;
  onRemove?: (e: any) => void;
  disableSave?: boolean;
  disableRemove?: boolean;
  disableNameChange?: boolean;
  disableDescriptionChange?: boolean;
  descriptionVisible?: boolean;
  statusVisible?: boolean;
  loading: boolean;
}

class State {}

export default ChartEditorComponent;
